// extracted by mini-css-extract-plugin
module.exports = {"statementContainer":"Statement_statementContainer__iCIZH","statementText":"Statement_statementText__Ty6Ko"};